/**
 * STATUS BADGE CELL
 * Cellule pour afficher un badge de statut avec des couleurs dynamiques
 */

import { Badge } from '@/components/ui/badge';

interface StatusConfig {
  bg: string;
  text: string;
  border: string;
}

interface StatusBadgeCellProps<T extends string> {
  status: T;
  labels: Record<T, string>;
  colors: Record<T, StatusConfig>;
  className?: string;
}

export function StatusBadgeCell<T extends string>({
  status,
  labels,
  colors,
  className,
}: StatusBadgeCellProps<T>) {
  const config = colors[status];
  const label = labels[status];

  return (
    <Badge className={`${config.bg} ${config.text} border ${config.border} ${className || ''}`}>
      {label}
    </Badge>
  );
}
